export default __webpack_public_path__ + "static/media/HEALTH_SAFETY.be6b0573.png";